import React, { useState } from "react";
import { isBlockOpenLoop } from "../../utils/globals";
import BrandVerificationPopUp from "../BrandVerificationPopUp";
import KybVerificationPopUp from "../KybVerificationPopUp";
import { isKybApprovalRequired } from "../../modules/Campaign/utils/campaignUtils";
import { Icon } from "@plum-xoxo/admin-dsm";
const env = process.env.NODE_ENV || "production";
const config = require(`../../config/config.${env}.json`);
import styled from "styled-components";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";

const IconDelete = styled(Icon).attrs()`
  background: ${(props) => props.theme.palette.orange.c100};
  border-radius: 50%;
`;

const BorderedDiv = styled.div`
  border: 1px solid ${(props) => props.theme.palette.light.c300};
`;

const PlumProBox = (props) => {
  let classname = props.classname || "";
  let stylename = props.stylename || "";
  let voucherUrl = props.voucherUrl || "https://via.placeholder.com/150";
  let discount = props.discount || "";
  let price = props.price;
  let currencyCode = props.currencyCode;
  let imageClass = props.imageClass || "";
  let cardTextClass = props.cardTextClass || "";
  let cardTextLength = props.cardTextLength || 25;
  let isDelete = props.isDelete || 0;
  let company_id = props.company_id || null;
  let bgImageClass = props.bgImageClass || "";
  let isSelectedImage = props.isSelectedImage || false;
  let emailTemplate = props.emailTemplate || false;
  const product_id = props.product_id || 0;
  const amazonProdId = config.amazon_india_prod_id;
  const voucher_category = props.voucher_category || "closed_loop";
  const kyb_status = props.kyb_status || 0;
  const { kyb_approval_required, kyb_approval_status } = props;

  const [tooltipOpen, toggleToolTip] = useState(false);

  const toggle = () => {
    toggleToolTip(!tooltipOpen);
  };

  const checkIfAmazonKyc = (product_id) => {
    const { kyc_approve = 0 } = props;
    if (amazonProdId === product_id) {
      if (kyc_approve === 0) {
        return false;
      }
      return true;
    }
    return true;
  };

  const tooltipstyle = {
    background: "#853a8e",
    fontSize: "14px",
    fontWeight: "400",
    width: "400px",
    display: "inline-block",
    textAlign: "left",
  };

  const bgImageUrl = voucherUrl
    ? `url("${voucherUrl.split(" ").join("%20")}")`
    : "";
  return (
    <div>
      <div
        className={`card ${classname} ${
          !checkIfAmazonKyc(product_id) ||
          isKybApprovalRequired({ kyb_approval_required, kyb_approval_status })
            ? "amazonIndProduct"
            : ""
        } ${
          isBlockOpenLoop(voucher_category, kyb_status) ? "openLoopProduct" : ""
        }
        ${isSelectedImage ? "card-body-shadow" : ""}
        `}
        style={{
          stylename,
          color: "#000000",
          position: "relative",
          cursor:
            !checkIfAmazonKyc(product_id) ||
            isKybApprovalRequired({
              kyb_approval_required,
              kyb_approval_status,
            }) ||
            isBlockOpenLoop(voucher_category, kyb_status)
              ? "not-allowed"
              : "",
        }}
      >
        {discount ? (
          <div className="float-right discount">{discount}</div>
        ) : null}

        <div onClick={props.showTnC} className={`card-body ${bgImageClass}`}>
          <BorderedDiv
            style={{
              height: emailTemplate ? "100px" : "160px",
              backgroundImage: bgImageUrl,
              borderRadius: "4px",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              filter:
                !checkIfAmazonKyc(product_id) ||
                isKybApprovalRequired({
                  kyb_approval_required,
                  kyb_approval_status,
                }) ||
                isBlockOpenLoop(voucher_category, kyb_status)
                  ? "grayscale(1)"
                  : "",
            }}
          />
          {isDelete && company_id != null ? (
            <IconDelete
              className="delete_icon"
              iconName="Delete"
              size="18"
              onClick={(e) => {
                props.deleteCardImage(e, props.imageId);
              }}
            />
          ) : null}
          {isSelectedImage ? (
            <span style={{ top: "12px", right: "12px", position: "absolute" }}>
              {/* <IconConfirm
                iconName="Confirm"
                size="18"
                color="common"
                shade="white"
              /> */}
              <Icon
                color="primary"
                iconName="PlumCheckbox"
                onClick={() => {}}
                shade="c02"
                size="23"
                className="ml-auto"
              />
            </span>
          ) : null}
          {/* <img className={`w-100 ${imageClass}`} src={voucherUrl} /> */}
        </div>
        {props && props.name ? (
          <>
            {/* {props.name.length > cardTextLength ? (
              <Tooltip
                placement="bottom"
                style={tooltipstyle}
                isOpen={tooltipOpen}
                target={`tip${props.cardId}`}
                toggle={toggle}
                className="plumproarrwcolor"
              >
                {props.name}
              </Tooltip>
            ) : null} */}
            {/* <CardText
              className={cardTextClass + " text-primary"}
              id={`tip${props.cardId}`}
            >
              {props.name.length > cardTextLength
                ? `${props.name.slice(0, cardTextLength)}...`
                : props.name}
            </CardText> */}
            <div>
              {isSelectedImage ? (
                <Typography color="blue" shade="c200">
                  {props.name.length > cardTextLength
                    ? `${props.name.slice(0, cardTextLength)}...`
                    : props.name}
                </Typography>
              ) : (
                <Typography color="dark" shade="c300">
                  {props.name.length > cardTextLength
                    ? `${props.name.slice(0, cardTextLength)}...`
                    : props.name}
                </Typography>
              )}
            </div>
          </>
        ) : null}
        {!checkIfAmazonKyc(product_id) ||
        isKybApprovalRequired({
          kyb_approval_required,
          kyb_approval_status,
        }) ? (
          <BrandVerificationPopUp
            redirectToVerifications={(e) => props.redirectToVerifications(e)}
            brandName={props.name}
          />
        ) : null}
        {isBlockOpenLoop(voucher_category, kyb_status) ? (
          <KybVerificationPopUp
            redirectToSubmitKyb={(e) => props.redirectToSubmitKyb(e)}
            kyb_status={kyb_status}
          />
        ) : null}
      </div>
    </div>
  );
};

export default PlumProBox;
